
import vps_data from "~/data/vpc.js";
export default {
  computed: {
    sliderItem() {
      return this.items[this.showingIndex];
    },
    sliderItems() {
      return this.items;
    },
  },
  data() {
    return {
      items: vps_data.customers,
      showingIndex: 0,
    };
  },
  methods: {
    nextSlide() {
      if (this.canGoNext()) this.showingIndex++;
    },
    prevSlide() {
      if (this.canGoPrev()) this.showingIndex--;
    },
    canGoNext() {
      return this.showingIndex < this.sliderItems.length - 1;
    },
    canGoPrev() {
      return this.showingIndex > 0;
    },
  },
};
